import { LazyMotion as FramerLazyMotion } from 'motion/react';
import { ReactNode } from 'react';

interface Props {
  children: ReactNode;
}

const LazyMotion = ({ children }: Props) => {
  return (
    <FramerLazyMotion
      features={() =>
        import('./features').then((resolve) => resolve.domAnimation)
      }
      strict
    >
      {children}
    </FramerLazyMotion>
  );
};

export default LazyMotion;
